import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GUEST_ROUTES } from 'routes/routes';
import { ChatItem } from 'services/api/chatsApi';
import styled from 'styled-components';

interface TryOurChatsSectionProps {
  chats: ChatItem[];
}

const TryOurChatsSection: React.FC<TryOurChatsSectionProps> = ({ chats }) => {
  const [showAll, setShowAll] = useState(false);

  if (!chats || chats.length === 0) return null;

  const displayedChats = showAll ? chats : chats.slice(0, 9);
  const shouldShowViewAll = chats.length > 9;

  return (
    <TryOurChatsSectionWrapper>
      <TryOurChatsTitle>Try our chats</TryOurChatsTitle>
      <ChatsContainer>
        {displayedChats.map((chat) => (
          <ChatTag key={chat.id} to={GUEST_ROUTES.CHAT(chat.name)}>
            {chat.title}
          </ChatTag>
        ))}
        {shouldShowViewAll && (
          <ViewAllButton onClick={() => setShowAll(!showAll)}>
            {showAll ? 'Show less' : 'View all'}
          </ViewAllButton>
        )}
      </ChatsContainer>
    </TryOurChatsSectionWrapper>
  );
};

export default TryOurChatsSection;

const TryOurChatsSectionWrapper = styled.section`
  margin-bottom: 48px;
  
  @media (max-width: 968px) {
    margin-left: 16px;
    margin-right: 16px;
  }
`;

const TryOurChatsTitle = styled.h3`
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  color: #FFF;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

const ChatsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

const ChatTag = styled(Link)`
  font-family: "Nunito Sans";
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  color: rgba(169, 169, 169, 1);
  background-color: rgba(29, 29, 29, 1);
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.1s;
  text-decoration: none;
  
  &:first-letter {
    text-transform: uppercase;
  }
  
  &:hover {
    color: white;
    background-color: rgba(255, 126, 85, 1);
  }
`;

const ViewAllButton = styled.button`
  font-family: "Nunito Sans";
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  color: white;
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  background: none;
  border: none;
  
  &:hover {
    opacity: 0.8;
  }
`; 